import React from 'react'
import CSSMatrix3DDistortion from '../matrix3ddistortion'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'

const style = {
    positionalMediaContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        maskImage: ({ fade }) => (fade ? 'radial-gradient(circle at 50% 50%, black 40%, transparent 50%)' : 'inital'),
        WebkitMaskImage: ({ fade }) =>
            fade ? 'radial-gradient(circle at 50% 50%, black 40%, transparent 50%)' : 'intial',
    },
}

const styleSheet = injectSheet(style)

const PositionalMediaPlayer = ({
    classes,
    forwardRef,
    autoPlay,
    preload,
    src,
    poster,
    points,
    x,
    y,
    z,
    width,
    height,
    children,
    onTimeUpdate,
    onPause,
    onPlay,
    onSeeked,
    onEnded,
    onLoadedMetadata,
    zIndex,
}) => (
    <div>
        <CSSMatrix3DDistortion
            className={classes.positionalMediaContainer}
            points={points}
            x={x}
            y={y}
            z={z}
            width={width}
            height={height}
            zIndex={zIndex}
        >
            <video
                ref={forwardRef}
                preload={preload}
                autoPlay={autoPlay}
                src={src}
                poster={poster}
                onTimeUpdate={onTimeUpdate}
                onPause={onPause}
                onPlay={onPlay}
                onSeeked={onSeeked}
                onEnded={onEnded}
                onLoadedMetadata={onLoadedMetadata}
            />
        </CSSMatrix3DDistortion>
        {children}
    </div>
)

PositionalMediaPlayer.defaultProps = {
    autoPlay: false,
    preload: 'auto', // auto - browser should load the entire video when the page loads
    // metadata -  browser should load only metadata when the page loads
    // none - browser should NOT load the video when the page loads
    src: undefined,
    points: [],
    x: 0,
    y: 0,
    z: 0,
}

export default compose(styleSheet)(PositionalMediaPlayer)
